import { get, post } from '@api/request';

export async function fetchEstimateLayout(
  { appraisalNoticeService },
  authenticationToken,
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimate/layout`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEstimateData(
  { appraisalNoticeService },
  authenticationToken,
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimate/sampledata`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function calcEstimateData(
  { appraisalNoticeService },
  authenticationToken,
  payload,
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimate/calculate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
